<script lang="ts">
  import {createEventDispatcher} from 'svelte';
  import {VideoService} from '@/services';
  import Dialog from '../../../components/dialog/Dialog.svelte';
  import type {Video} from '@/types/project';
  import * as Store from '@/store';
  import Swal from 'sweetalert2';

  export let isDeleteDialogOpen = false;
  export let selectedVideos: Video[] = [];

  const dispatch = createEventDispatcher();
  const videoService = new VideoService();

  let isDeletingVideo = false;

  async function deleteVideos() {
    isDeletingVideo = true;

    try {
      const results = await Promise.all(
        selectedVideos.map(video => {
          return videoService
            .deleteVideo(video.id)
            .then(() => video.id)
            .catch(() => null);
        })
      );

      if (!results.every(result => result !== null)) throw 'some results were null';

      dispatch('delete', {selectedVideos: selectedVideos.map(video => video.id)});

      selectedVideos = [];
      isDeletingVideo = isDeleteDialogOpen = false;

      // remove deleted videos from the Store.videos but commented out
      await Store.videos.getVideoList(1, Store.videos.videoLength());
      // Store.videos.update((videos) => {
      //     results.forEach((id) => {
      //         if (!id) return;
      //         videos.files = videos.files.filter((video) => video.id !== id);
      //     })
      //     return videos;
      // })

      Swal.fire({
        position: 'bottom-end',
        icon: 'success',
        title: 'Video(s) Deleted',
        showConfirmButton: false,
        timer: 1500,
        toast: true
      });
    } catch (error) {
      console.error('delete error', error);

      Swal.fire({
        position: 'bottom-end',
        icon: 'error',
        title: 'Failed to Delete Video',
        showConfirmButton: false,
        timer: 1500,
        toast: true
      });
    }
  }
</script>

<Dialog bind:isDialogOpen={isDeleteDialogOpen} useIfShow={true}>
  <div class="pointer-events-none flex h-full w-full items-end justify-center lg:items-center">
    <div
      class="pointer-events-auto h-auto w-full min-w-[280px] rounded-t-2xl border border-zinc-400 bg-white p-12 shadow-lg dark:border-zinc-600 dark:bg-zinc-700 lg:max-w-[680px] lg:rounded-3xl"
    >
      <div class="flex items-center p-6 text-zinc-900 dark:text-zinc-200">
        <div class="flex items-center gap-3 py-1.5">
          <!-- <div class="rounded-full px-2 p-2 font-bold bg-rose-500 text-zinc-100 flex items-center">
                        <i class="fa-regular fa-trash"></i>
                    </div> -->
          <h1 class="text-lg font-bold text-dark">Delete Video{selectedVideos.length > 1 ? 's' : ''}</h1>
        </div>
        <button on:click={() => (isDeleteDialogOpen = false)} class="ml-auto rounded-full px-2 hover:bg-zinc-100">
          <i class="fa-solid fa-xmark p-2 text-lg text-black" aria-hidden="true"></i>
        </button>
      </div>
      <!-- <hr class="border dark:border-zinc-600"> -->
      <div class="grid pt-2">
        <h1 class="pb-4 text-xl font-bold text-zinc-900 dark:text-zinc-100">
          Are you sure you want to delete {selectedVideos.length > 1 ? 'multiple videos' : 'this video'}?
        </h1>
        <div class="flex items-center gap-2 rounded-lg border border-rose-500 p-2">
          <div class="bg-rose-500/20 p-2 uppercase text-rose-600 dark:bg-rose-400/10 dark:text-rose-500">NOTE</div>
          <p class="text-zinc-700 dark:text-zinc-300">
            All sermon clips, discussion guides, and transcriptions will also be deleted.
          </p>
        </div>
      </div>
      <!-- <hr class="border dark:border-zinc-600"> -->
      <div class="flex justify-end gap-2 pt-6">
        <button
          on:click={() => (isDeleteDialogOpen = false)}
          class="{isDeletingVideo
            ? 'bg-zinc-100'
            : 'border border-2 border-zinc-400'} flex w-full items-center rounded-md px-3 py-2 font-medium text-zinc-400 lg:w-auto"
          disabled={isDeletingVideo}
        >
          <span>Cancel</span>
        </button>
        <button
          on:click={deleteVideos}
          class="flex w-full items-center gap-1 rounded-md bg-rose-500 px-3 py-2 font-medium text-zinc-100 hover:bg-rose-600 lg:w-auto"
          disabled={isDeletingVideo}
        >
          <div
            class="{isDeletingVideo
              ? ''
              : 'hidden'} spinner h-4 w-4 !border-zinc-100 !border-t-rose-500 dark:!border-zinc-700 dark:!border-t-rose-500"
          ></div>
          <span>Delete</span>
        </button>
      </div>
    </div>
  </div>
</Dialog>
